import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=c0aa4ae4&scoped=true&"
import script from "./page-not-found.vue?vue&type=script&lang=ts&"
export * from "./page-not-found.vue?vue&type=script&lang=ts&"
import style0 from "./page-not-found.vue?vue&type=style&index=0&id=c0aa4ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aa4ae4",
  null
  
)

export default component.exports